import InputNumberWithControl from "./input-number-with-control";


const Inputs = {
     NumberControl : InputNumberWithControl
}

export default Inputs;